export let contentUrlPrefix = '';
export const setContentUrlPrefix = (url: string) => contentUrlPrefix = url || '';
export const getContentUrlPrefix = () => contentUrlPrefix;
